var map = {
	"./Ambulance_Right_Black.png": 786,
	"./BackhoeLoader_Right_Black.png": 787,
	"./BoxTrailer_Right_Black.png": 788,
	"./Bulldozer_Right_Black.png": 789,
	"./Cabriolet_Right_Black.png": 790,
	"./Cabriolet_Right_Blue.png": 791,
	"./Cabriolet_Right_Green.png": 792,
	"./Cabriolet_Right_Grey.png": 793,
	"./Cabriolet_Right_Red.png": 794,
	"./Cabriolet_Right_Yellow.png": 795,
	"./CamperVan_Right_Black.png": 796,
	"./CamperVan_Right_Blue.png": 797,
	"./CamperVan_Right_Green.png": 798,
	"./CamperVan_Right_Grey.png": 799,
	"./CamperVan_Right_Red.png": 800,
	"./CamperVan_Right_Yellow.png": 801,
	"./Car_Right_Black.png": 802,
	"./Car_Right_Blue.png": 803,
	"./Car_Right_Green.png": 804,
	"./Car_Right_Grey.png": 805,
	"./Car_Right_Red.png": 806,
	"./Car_Right_Yellow.png": 807,
	"./Caravan_Right_Black.png": 808,
	"./Coach_Right_Black.png": 809,
	"./Coach_Right_Blue.png": 810,
	"./Coach_Right_Green.png": 811,
	"./Coach_Right_Grey.png": 812,
	"./Coach_Right_Red.png": 813,
	"./Coach_Right_Yellow.png": 814,
	"./ConcretePump_Right_Black.png": 815,
	"./ConcretePump_Right_Blue.png": 816,
	"./ConcretePump_Right_Green.png": 817,
	"./ConcretePump_Right_Grey.png": 818,
	"./ConcretePump_Right_Red.png": 819,
	"./ConcretePump_Right_Yellow.png": 820,
	"./ContainerizedGeneratorTrailer_Right_Black.png": 821,
	"./Excavator_Right_Black.png": 822,
	"./ExecutiveCar_Right_Black.png": 823,
	"./ExecutiveCar_Right_Blue.png": 824,
	"./ExecutiveCar_Right_Green.png": 825,
	"./ExecutiveCar_Right_Grey.png": 826,
	"./ExecutiveCar_Right_Red.png": 827,
	"./ExecutiveCar_Right_Yellow.png": 828,
	"./FarmTractor_Right_Black.png": 829,
	"./FlatbedTrailer_Bulkhead_Right_Black.png": 830,
	"./ForkliftTruck_Right_Black.png": 831,
	"./FuelTankTruck_Right_Black.png": 832,
	"./GullyEmptier_Right_Black.png": 833,
	"./Hatchback_Right_Black.png": 834,
	"./Hatchback_Right_Blue.png": 835,
	"./Hatchback_Right_Green.png": 836,
	"./Hatchback_Right_Grey.png": 837,
	"./Hatchback_Right_Red.png": 838,
	"./Hatchback_Right_Yellow.png": 839,
	"./LuxuryCar_Right_Black.png": 840,
	"./LuxuryCar_Right_Blue.png": 841,
	"./LuxuryCar_Right_Green.png": 842,
	"./LuxuryCar_Right_Grey.png": 843,
	"./LuxuryCar_Right_Red.png": 844,
	"./LuxuryCar_Right_Yellow.png": 845,
	"./MixerTruck_Right_Black.png": 846,
	"./MixerTruck_Right_Blue.png": 847,
	"./MixerTruck_Right_Green.png": 848,
	"./MixerTruck_Right_Grey.png": 849,
	"./MixerTruck_Right_Red.png": 850,
	"./MixerTruck_Right_Yellow.png": 851,
	"./Motorcycle_Right_Black.png": 852,
	"./Motorcycle_Right_Blue.png": 853,
	"./Motorcycle_Right_Green.png": 854,
	"./Motorcycle_Right_Grey.png": 855,
	"./Motorcycle_Right_Red.png": 856,
	"./Motorcycle_Right_Yellow.png": 857,
	"./RecoveryTruck_Right_Black.png": 858,
	"./ReeferTrailer_Right_Black.png": 859,
	"./RoadsideAssistanceCar_Right_Black.png": 860,
	"./RoadsideAssistanceCar_Right_Blue.png": 861,
	"./RoadsideAssistanceCar_Right_Green.png": 862,
	"./RoadsideAssistanceCar_Right_Grey.png": 863,
	"./RoadsideAssistanceCar_Right_Red.png": 864,
	"./RoadsideAssistanceCar_Right_Yellow.png": 865,
	"./ServiceVan_Right_Black.png": 866,
	"./ServiceVan_Right_Blue.png": 867,
	"./ServiceVan_Right_Green.png": 868,
	"./ServiceVan_Right_Grey.png": 869,
	"./ServiceVan_Right_Red.png": 870,
	"./ServiceVan_Right_Yellow.png": 871,
	"./SewerCleaningTruck_Right_Black.png": 872,
	"./SewerCleaningTruck_Right_Blue.png": 873,
	"./SewerCleaningTruck_Right_Green.png": 874,
	"./SewerCleaningTruck_Right_Grey.png": 875,
	"./SewerCleaningTruck_Right_Red.png": 876,
	"./SewerCleaningTruck_Right_Yellow.png": 877,
	"./SteamRoller_Right_Black.png": 878,
	"./TankerTrailer_Right_Black.png": 879,
	"./Taxi_Right_Black.png": 880,
	"./Taxi_Right_Blue.png": 881,
	"./Taxi_Right_Green.png": 882,
	"./Taxi_Right_Grey.png": 883,
	"./Taxi_Right_Red.png": 884,
	"./Taxi_Right_Yellow.png": 885,
	"./TowTruck_Right_Black.png": 886,
	"./TowTruck_Right_Blue.png": 887,
	"./TowTruck_Right_Green.png": 888,
	"./TowTruck_Right_Grey.png": 889,
	"./TowTruck_Right_Red.png": 890,
	"./TowTruck_Right_Yellow.png": 891,
	"./TractorFlatbedTrailer_Right_Black.png": 892,
	"./TractorFlatbedTrailer_Right_Blue.png": 893,
	"./TractorFlatbedTrailer_Right_Green.png": 894,
	"./TractorFlatbedTrailer_Right_Grey.png": 895,
	"./TractorFlatbedTrailer_Right_Red.png": 896,
	"./TractorFlatbedTrailer_Right_Yellow.png": 897,
	"./TractorTrailer_Right_Black.png": 898,
	"./TractorTrailer_Right_Blue.png": 899,
	"./TractorTrailer_Right_Green.png": 900,
	"./TractorTrailer_Right_Grey.png": 901,
	"./TractorTrailer_Right_Red.png": 902,
	"./TractorTrailer_Right_Yellow.png": 903,
	"./TractorUnit_Right_Black.png": 904,
	"./TractorUnit_Right_Blue.png": 905,
	"./TractorUnit_Right_Green.png": 906,
	"./TractorUnit_Right_Grey.png": 907,
	"./TractorUnit_Right_Red.png": 908,
	"./TractorUnit_Right_Yellow.png": 909,
	"./Truck_Right_Black.png": 910,
	"./Truck_Right_Blue.png": 911,
	"./Truck_Right_Green.png": 912,
	"./Truck_Right_Grey.png": 913,
	"./Truck_Right_Red.png": 914,
	"./Truck_Right_Yellow.png": 915,
	"./UltraSilentGeneratorTrailer_Right_Black.png": 916,
	"./WasteTankerTrailer_Right_Black.png": 917,
	"./WaterTankTruck_Right_Black.png": 918,
	"./WaterTankTruck_Right_Blue.png": 919,
	"./WaterTankTruck_Right_Green.png": 920,
	"./WaterTankTruck_Right_Grey.png": 921,
	"./WaterTankTruck_Right_Red.png": 922,
	"./WaterTankTruck_Right_Yellow.png": 923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;